import type { PolicyEvaluation } from '@content-search/domain';
import { Badge, BadgeSize, BadgeVariant } from '@soteria/design-system-ve';

import * as styles from './PolicyDisplay.css';

interface PolicySectionProps {
  title: string;
  policies: PolicyEvaluation[];
  showTriggeredBadge?: boolean;
  maxDisplayed?: number;
}

/**
 * Displays a section of policy evaluations (triggered or nontriggered)
 */
export function PolicySection({ title, policies, showTriggeredBadge = false, maxDisplayed = 10 }: PolicySectionProps) {
  const displayedPolicies = policies.slice(0, maxDisplayed);
  const remainingCount = policies.length - maxDisplayed;

  return (
    <div className={styles.policySection}>
      <div className={styles.policySectionTitle}>
        {title} ({policies.length})
      </div>
      <div className={styles.policyList}>
        {displayedPolicies.map(evaluation => (
          <div key={evaluation.policyId} className={styles.policyBadgeContainer}>
            <Badge size={BadgeSize.Small} text={evaluation.policyName} title={evaluation.reason} />
            {showTriggeredBadge && <Badge size={BadgeSize.Small} text="TRIGGERED" variant={BadgeVariant.Warning} />}
          </div>
        ))}
        {remainingCount > 0 && (
          <div className={styles.morePoliciesText}>
            + {remainingCount} more {remainingCount === 1 ? 'policy' : 'policies'}
          </div>
        )}
      </div>
    </div>
  );
}
